$(document).ready(function() {
    // Open the first FAQ by default
    let firstFaq = $(".faq-list .faq-item").first();
    firstFaq.addClass("active");
    firstFaq.find(".faq-answer").slideDown();

    // FAQ question click handler
    $(".faq-list").on("click", ".faq-question", function() {
        let faqItem = $(this).closest(".faq-item");
        let faqAnswer = faqItem.find(".faq-answer");

        // If the clicked item is already active, close it
        if (faqItem.hasClass("active")) {
            faqItem.removeClass("active");
            faqAnswer.slideUp();
        } else {
            // Close all others
            $(".faq-list .faq-item").removeClass("active").find(".faq-answer").slideUp();

            // Open the clicked one
            faqItem.addClass("active");
            faqAnswer.slideDown();
        }
    });
});
